import { SignalRState } from './messages.model';
import { SignalRActions, MessageActionTypes } from './messages.actions';

export const inRoomSignalRFeatureKey = 'inroom-signalr';

const initialstate: SignalRState = {
  alarmEvent: null,
  blindsEvent: null,
  buttonPressEvent: null,
  curtainEvent: null,
  fanSpeedEvent: null,
  ligthEvent: null,
  mediaStateEvent: null,
  temperatureEvent: null,
  moodStartedEvent: null,
  roomStateEvent: null,
  reservationStateEvent: null,
  attributesEvent: null,
};

export function signalRReducer(state: SignalRState = initialstate, action: SignalRActions): SignalRState {
  switch (action.type) {
    case MessageActionTypes.ALARM_CHANGED: {
      return {
        ...state,
        alarmEvent: action.payload,
      };
    }
    case MessageActionTypes.BLINDS_CHANGED: {
      return {
        ...state,
        blindsEvent: action.payload,
      };
    }
    case MessageActionTypes.BUTTON_PRESSED: {
      return {
        ...state,
        buttonPressEvent: action.payload,
      };
    }
    case MessageActionTypes.CURTAIN_CHANGED: {
      return {
        ...state,
        curtainEvent: action.payload,
      };
    }
    case MessageActionTypes.FANSPEED_CHANGED: {
      return {
        ...state,
        fanSpeedEvent: action.payload,
      };
    }
    case MessageActionTypes.LIGHT_CHANGED: {
      return {
        ...state,
        ligthEvent: action.payload,
      };
    }
    case MessageActionTypes.MEDIA_STATE_CHANGED: {
      return {
        ...state,
        mediaStateEvent: action.payload,
      };
    }
    case MessageActionTypes.TEMPERATURE_CHANGED: {
      return {
        ...state,
        temperatureEvent: action.payload,
      };
    }
    case MessageActionTypes.MOOD_STARTED: {
      return {
        ...state,
        moodStartedEvent: action.payload,
      };
    }
    case MessageActionTypes.ROOM_STATE_CHANGED: {
      return {
        ...state,
        roomStateEvent: action.payload,
      };
    }
    case MessageActionTypes.RESERVATION_STATE_CHANGED: {
      return {
        ...state,
        reservationStateEvent: action.payload,
      };
    }
    case MessageActionTypes.ATTRIBUTES_CHANGED: {
      return {
        ...state,
        attributesEvent: action.payload,
      };
    }
    default:
      return state;
  }
}
